import React, { useEffect, useState } from "react";
import DealerService from "../../service/DealerService";
import { toast } from "react-toastify";
import { InventoryService } from "../../service";

const ModalBuySubscriptions = (props) => {
    const [packDetail, setPackDetail] = useState({});
    const [skuTypes, setSkuTypes] = useState([]);
    const [additionalDiscount, setAdditionalDiscount] = useState(0);
    const [paymentProof, setPaymentProof] = useState(null);
    const [skuMaster, setSkuMaster] = useState({});
    const [dealerIdHash, setDealerIdHash] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (props?.data?.package_details) {
            setPackDetail(props?.data?.package_details);
        }

        if (props?.data?.sku_types) {
            setSkuTypes(props?.data?.sku_types);
            let skuMasterDetails = props?.data?.sku_types?.find((v) => +v.id === props?.data?.package_details?.sku_type);
            if (skuMasterDetails) setSkuMaster(skuMasterDetails);
        }

        if (props?.data?.dealer_id_hash) {
            setDealerIdHash(props?.data?.dealer_id_hash);
        }
    }, [props]);

    const calculateVAT = (price) => Math.floor(price * 0.02898);
    const calculateNetPrice = (price, vat, discount, additionalDiscount) => {
        return (price - discount - additionalDiscount);
    };

    const handleAdditionalDiscountChange = (e) => {
        setAdditionalDiscount(Number(e.target.value));
    };

    const handleFileChange = (e) => {
        setPaymentProof(e.target.files[0]); // Capture the first file
    };

    // const price = (+packDetail.price || 0) +  (+packDetail.discount_to_be_shown || 0);
    const price = (+packDetail.price || 0);
    const discount = +packDetail.discount_to_be_shown || 0;
    const vat = packDetail?.vat || 0;  //calculateVAT(price);
    const netPrice = calculateNetPrice(price, vat, discount, additionalDiscount);

    const handleSubscriptionPayment = async () => {
        setLoading(true);

        const subscriptionPayload = {
            amount: parseFloat(packDetail?.price),
            dealer_id_hash: dealerIdHash,
            packageId: String(packDetail?.id),
        };

        try {
            const response = await DealerService.createInvoice(subscriptionPayload);
            if (response && response?.status === 200 && response?.data && response?.data?.status === 200) {
                let result = response?.data;
                let data = result && result?.data;

                if (data?.invoice_url) {
                    window.location.href = data.invoice_url;
                }
            } else if (response?.data && response?.data?.status !== 200) {
                toast.error(response?.data?.message);
            }
        } catch (error) {
            console.log("Invoice creation failed:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleActivatePayment = async () => {
        setLoading(true);
        try {
            let fileUrl = null;
            // Step 1: Upload file if selected
            if (paymentProof) {
                const formData = new FormData();
                formData.append("upload_type", 'dealer_docs');
                formData.append("dealer_id", dealerIdHash);
                formData.append("images", paymentProof);

                const response = await InventoryService.uploadFilesToS3(formData, {
                    "Content-Type": "multipart/form-data",
                });

                if (response?.data?.status === 200) {
                    const uploadedFile = response.data.data[0];
                    if (uploadedFile && uploadedFile !== "not_updated") {
                        fileUrl = uploadedFile.file_url;
                    }
                }
            }

            // Step 2: Build payload
            const payload = {
                dealer_id_hash: dealerIdHash,
                package_id: packDetail?.id,
                additional_discount: additionalDiscount || 0,
                file_url: fileUrl || '',
                net_price: netPrice,
            };


            // Step 3: Call your API (example)
            const activateResponse = await DealerService.activateSubscription(payload);
            if (activateResponse?.status === 200 && activateResponse?.data?.status === 200) {
                toast.success("Subscription activated successfully!");
                props?.fetchDealerSKUSubscriptionList(1);
                props?.handleClose();
                props?.data?.fetchEditData();
            } else if (activateResponse?.data && activateResponse?.data?.status !== 200) {
                toast.error( activateResponse?.data?.message || "Activation failed.");
            }

        } catch (error) {
            console.error("Error during activation:", error);
            toast.error("Something went wrong during activation.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <table className={loading ? "table-style-2 loading" : "table-style-2"}>
                <tbody>
                    <tr>
                        <td>Name</td>
                        <td><span className='f-semibold'>{packDetail?.name}</span></td>
                    </tr>
                    <tr>
                        <td>Quota</td>
                        <td><span className='f-semibold'>{packDetail?.quota}</span></td>
                    </tr>
                    <tr>
                        <td>Total Leads</td>
                        <td><span className='f-semibold'>{packDetail?.total_leads}</span></td>
                    </tr>
                    <tr>
                        <td>Active Period(in days)</td>
                        <td><span className='f-semibold'>{`${packDetail?.active_period_days} Days`}</span></td>
                    </tr>
                    <tr>
                        <td>SKU Type</td>
                        <td>
                            <span className='f-semibold'>{
                                skuTypes.find((sType) => +sType?.value === +packDetail?.sku_type)?.label || ''
                            }</span>
                        </td>
                    </tr>
                    <tr>
                        <td>Price</td>
                        <td><span className='f-semibold'>{packDetail?.price}</span></td>
                    </tr>
                    <tr>
                        <td>VAT (Already included in the Price)</td>
                        <td><span className='f-semibold'>{packDetail?.vat}</span></td>
                    </tr>
                    <tr>
                        <td>Discount</td>
                        <td><span className='f-semibold'>{packDetail?.discount_to_be_shown}</span></td>
                    </tr>
                    {props?.userType === 'admin' && (<tr>
                        <td>Additional Discount</td>
                        <td><input
                            type="number"
                            value={additionalDiscount}
                            onChange={handleAdditionalDiscountChange}
                            placeholder="Enter additional discount"
                            min="0"
                        /></td>
                    </tr>)}
                    <tr>
                        <td>Net Price</td>
                        <td><span className='f-semibold'>{netPrice.toLocaleString()}</span></td>
                    </tr>
                    {props?.userType === 'admin' && (<tr>
                        <td>Upload Proof</td>
                        <td><input
                            type="file"
                            onChange={handleFileChange}
                            accept="image/*,application/pdf"
                        /></td>
                    </tr>)}
                </tbody>
            </table>
            
            {props?.userType === 'admin' &&
                <button 
                    type="button"
                    className="btn-solid bg-orange w-auto t-uppercase p-xxl-l p-xxl-r m-xl-t"
                    onClick={() => handleActivatePayment()}
                    disabled={loading}
                >
                    Activate
                </button>
            } 
            {props?.userType === 'dealer' &&
                <button
                    type="button"
                    className="btn-solid bg-orange w-auto t-uppercase p-xxl-l p-xxl-r m-xl-t"
                    onClick={() => handleSubscriptionPayment()}
                    disabled={loading}
                >
                    PROCEED FOR PAYMENT
                </button>
            }
        </div>
    );
};

export default ModalBuySubscriptions;
